import React from "react";

type WorkScheduleItem = {
  dayNumber: number;
  dayName: string;
  workingHour: string[];
};

type Props = {
  schedules: WorkScheduleItem[];
};

const WorkSchedule: React.FC<Props> = ({ schedules }) => {
  const todayApiDay = (new Date().getDay() + 6) % 7;

  return (
    <>
      {schedules.map((schedule) => {
        const isToday = schedule.dayNumber === todayApiDay;
        return (
          <div
            key={schedule.dayNumber}
            className="d-flex justify-content-between fs-7"
          >
            <p className={`mb-1 me-3${isToday ? " fw-bold" : ""}`}>
              {schedule.dayName}
            </p>
            <div>
              {schedule.workingHour.map((hour, i) => (
                <span
                  key={i}
                  className={`d-block text-start${isToday ? " fw-bold" : ""}`}
                >
                  {hour}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default WorkSchedule;
